$(function () {
  var $showAllButton = $(".FAQComponent-showAll"),
    maxVisibleQuestions = 5,
    visibleQuestionsAfterCollapse = 3,
    $faqList = $showAllButton.prev("ul");
  if ($faqList.children().length > maxVisibleQuestions) {
    $showAllButton.removeClass("hidden");
    $faqList.children("li:nth-child(" + visibleQuestionsAfterCollapse + ")").nextAll().addClass("hidden");
  }
  $showAllButton.on("click", function () {
    var $this = $(this),
      hideLabel = $this.data("close"),
      originalLabel = $this.data("original");
    if ($.trim($this.text()) === originalLabel) {
      // Opens
      $faqList.children("li").removeClass("hidden");
      $this.text(hideLabel);
    } else {
      //Closes
      $this.text(originalLabel);
      $faqList.children("li:nth-child(" + visibleQuestionsAfterCollapse + ")").nextAll().addClass("hidden");
    }
  });
});